import React, { Component} from 'react';
import * as scriptUtils from './utils/scriptUtils';
import { IoMdClose } from 'react-icons/io';
import { IoArrowBack } from 'react-icons/io5';
import './ChatUserInformationModal.css';
import ChatUserNFTs from './ChatUserNFTs';


class ChatUserNFTUploadModal extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div>
				<div className="bg-black opacity-50 top-16 md:w-[300px] h-screen mt-0 h-[600px] md:h-[calc(100vh-108px)] absolute z-0">
				</div>
				<div className="modalContainer">
					<div className="flex flex-col justify-center h-full">
						<div className="flex justify-start items-center" onClick={this.props.toggleNFTUploadFlow}>
							<IoArrowBack
								className="flex text-xs ml-4 absolute top-[8px] text-base font-medium cursor-pointer text-gray-400"
								size={20}
							/>
						</div>
						<div className="flex text-xs ml-10 absolute top-[8px] text-base font-medium cursor-pointer text-gray-400">
							BACK
						</div>
						<div className="text-white text-lg font-bold justify-center flex" >
							Select one of your NFTs
						</div>
						<div className="flex justify-center mt-2">
							<div className="w-10/12 bg-zinc-800 h-[184px] overflow-scroll">
								<ChatUserNFTs
									pfp={this.props.pfp}
									selectNFTPFP={this.props.selectNFTPFP}
                					userOwnedNFTs={this.props.userOwnedNFTs}
								/>
							</div>
						</div>
						<div className="flex justify-center mt-4">
							<div
								onClick={this.props.toggleNFTUploadFlow}
								className="bg-blue-600 w-10/12 cursor-pointer h-10 rounded-md text-white flex justify-center items-center font-semibold"
							>
								Continue
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default ChatUserNFTUploadModal;
